import { alpha } from '@mui/material/styles';
import { Box, CircularProgress, Typography } from '@mui/material';

type AppLoadingScreenProps = {
  message?: string;
  minHeight?: number | string;
  fullScreen?: boolean;
};

export default function AppLoadingScreen({
  message = 'Chargement en cours...',
  minHeight = '50vh',
  fullScreen = false,
}: AppLoadingScreenProps) {
  return (
    <Box
      sx={{
        minHeight: fullScreen ? '100dvh' : minHeight,
        display: 'grid',
        placeItems: 'center',
        px: { xs: 2.5, sm: 3 },
        py: { xs: 5, sm: 6 },
        position: 'relative',
        overflow: 'hidden',
        bgcolor: fullScreen ? 'background.default' : 'transparent',
        backgroundImage: (theme) => fullScreen
          ? `radial-gradient(circle at top, ${alpha(theme.palette.primary.light || theme.palette.primary.main, 0.12)}, transparent 42%), linear-gradient(180deg, ${alpha(theme.palette.background.paper, 0.96)} 0%, ${alpha(theme.palette.background.default, 0.92)} 100%)`
          : `linear-gradient(180deg, ${alpha(theme.palette.background.paper, 0.78)} 0%, ${alpha(theme.palette.background.default, 0.48)} 100%)`,
      }}
    >
      <Box
        sx={{
          width: '100%',
          maxWidth: 360,
          display: 'grid',
          justifyItems: 'center',
          gap: 2,
          textAlign: 'center',
          px: { xs: 3, sm: 4 },
          py: { xs: 3.5, sm: 4 },
          borderRadius: 4,
          border: (theme) => `1px solid ${alpha(theme.palette.primary.main, 0.08)}`,
          backgroundColor: (theme) => alpha(theme.palette.background.paper, fullScreen ? 0.9 : 0.82),
          boxShadow: (theme) => `0 18px 40px ${alpha(theme.palette.primary.main, 0.12)}`,
          backdropFilter: 'blur(14px)',
        }}
      >
        <Box
          sx={{
            width: 72,
            height: 72,
            display: 'grid',
            placeItems: 'center',
            borderRadius: '50%',
            background: (theme) => `radial-gradient(circle at 30% 30%, ${alpha(theme.palette.common.white, 0.95)}, ${alpha(theme.palette.primary.main, 0.1)})`,
            boxShadow: (theme) => `inset 0 1px 0 ${alpha(theme.palette.common.white, 0.8)}, 0 10px 24px ${alpha(theme.palette.primary.main, 0.14)}`,
          }}
        >
          <CircularProgress
            size={32}
            thickness={4.6}
            sx={{ color: 'primary.main' }}
          />
        </Box>
        <Typography variant="body1" sx={{ fontWeight: 600, color: 'text.primary', lineHeight: 1.5 }}>
          {message}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ maxWidth: 240 }}>
          Merci de patienter quelques instants.
        </Typography>
      </Box>
    </Box>
  );
}